import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { IbanInvoiceExpirationDto, InvoiceExpirationSettingsApi } from "api";

const invoiceExpirationSettingsApi = new InvoiceExpirationSettingsApi();

export interface InvoiceExpirationSettingsState {
  days?: number;
  hours?: number;
}

const initialState: InvoiceExpirationSettingsState = {
  days: undefined,
  hours: undefined,
};

export const getInvoiceExpirationSettings =
  createAsyncThunk<IbanInvoiceExpirationDto>(
    "invoiceExpirationSettings/get",
    async () => {
      const { data } =
        await invoiceExpirationSettingsApi.apiSettingsInvoiceExpirationGet();

      return data;
    }
  );

export const updateInvoiceExpirationSettings = createAsyncThunk<
  IbanInvoiceExpirationDto,
  IbanInvoiceExpirationDto | undefined
>("invoiceExpirationSettings/update", async (body) => {
  const { data } =
    await invoiceExpirationSettingsApi.apiSettingsInvoiceExpirationPost({
      ibanInvoiceExpiration: body,
    });
  return data;
});

const invoiceExpirationSettingsSlice = createSlice({
  name: "invoiceExpirationSettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getInvoiceExpirationSettings.fulfilled, (state, action) => {
      return {
        ...state,
        days: action.payload.days,
        hours: action.payload.hours,
      };
    });
    builder.addCase(
      updateInvoiceExpirationSettings.fulfilled,
      (state, action) => {
        return {
          ...state,
          days: action.payload.days,
          hours: action.payload.hours,
        };
      }
    );
  },
});

export default invoiceExpirationSettingsSlice.reducer;
